

















import { Vue, Component, Prop } from 'vue-property-decorator';

import Button from '@/components/atoms/Button/Button.vue';
import LinkedInIcon from '@/components/icons/LinkedIn.vue';
import CircleAddSolid from '@/components/icons/CircleAddSolid.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';

export enum EASocialMedia {
  facebook = 'facebook',
  linkedin = 'linkedin',
  twitter = 'twitter',
  copyLink = 'copyLink',
  more = 'more'
}

type IconProps = {
  displayName: string;
  slug: EASocialMedia;
  iconClass?: string;
  iconSVGComponent?: string;
};

@Component({
  components: {
    Typography,
    Button,
    LinkedInIcon,
    CircleAddSolid
  }
})
export default class SocialMediaButton extends Vue {
  @Prop({ required: true }) readonly socialMedia!: EASocialMedia;

  get socialMapper(): Record<EASocialMedia, IconProps> {
    return {
      [EASocialMedia.facebook]: {
        displayName: 'Facebook',
        iconClass: 'icon-facebook-logo',
        slug: EASocialMedia.facebook
      },
      [EASocialMedia.twitter]: {
        displayName: 'Twitter',
        iconClass: 'icon-twitter-logo',
        slug: EASocialMedia.facebook
      },
      [EASocialMedia.linkedin]: {
        displayName: 'Linkedin',
        iconSVGComponent: 'LinkedInIcon',
        slug: EASocialMedia.facebook
      },
      [EASocialMedia.copyLink]: {
        displayName: String(
          this.$t('common.components.socialMediaButton.copyLink')
        ),
        iconClass: 'icon-hiperlink',
        slug: EASocialMedia.facebook
      },
      [EASocialMedia.more]: {
        displayName: String(
          this.$t('common.components.socialMediaButton.more')
        ),
        iconSVGComponent: 'CircleAddSolid',
        slug: EASocialMedia.facebook
      }
    };
  }

  get socialMediaData() {
    return this.socialMapper[this.socialMedia];
  }
}
